export default __webpack_public_path__ + "static/media/product-image-hover-12.e4a79180.jpg";